import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dhl",
  "use": "icon-dhl-usage",
  "viewBox": "0 0 1033 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1033 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-dhl\"><path d=\"M943.428864 180.48H90.180864a85.248 85.248 0 1 1 0-170.496h852.992a85.248 85.248 0 1 1 0 170.496z m0 417.792H90.692864a85.248 85.248 0 1 1 0-170.496h852.224a85.248 85.248 0 1 1 0 170.496z m0 425.472H90.180864a85.504 85.504 0 1 1 0-170.752h852.992a85.504 85.504 0 1 1 0 170.752z m0 0\" p-id=\"7817\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol